import { coreLayoutCmsComponents } from '@/features/cms/components/CMS/CoreLayoutCmsComponents'
import { pageLayoutCmsComponents } from '@/features/cms/components/CMS/PageLayoutCmsComponents'
import { referenceComponents } from '@/features/cms/components/CMS/ReferenceRenderer'
import { modalCmsComponents } from '@/features/cms/components/CMS/ModalCmsComponents'
import {
  type Content,
  type CmsMappedComponents,
  type CmsReferenceComponents,
  type ModalContent,
} from '@/features/cms/components/CMS/types'

export const cmsComponents: CmsMappedComponents<
  Content['content_type_id'] | ModalContent['content_type_id']
> &
  CmsMappedComponents<CmsReferenceComponents['content_type_id']> = {
  ...referenceComponents,
  ...pageLayoutCmsComponents,
  ...coreLayoutCmsComponents,
  ...modalCmsComponents,
}
